export const DEFAULT_DATA = {
  prevElectricity: 0,
  currElectricity: 0,
  sumElectricity: 0,
  prevWater: 0,
  currWater: 0,
  sumWater: 0,
  prevGas: 0,
  currGas: 0,
  sumGas: 0,
};

export const ELECTRICITY_PRICE = 1.68;
export const WATER_PRICE = 27.87;
export const GAS_PRICE = 10.2;
